import { FC, MouseEventHandler, PropsWithChildren } from "react";

import { useApplication } from "@ryde/redux";

import { LeftBarLiStyled } from "./left-bar.styled";
import { NavButtonTooltipWrapper } from "./left-bar.tooltip";

interface ILeftBarButton extends PropsWithChildren {
  onMenuItemClick: MouseEventHandler<HTMLElement>;
  tooltip: string;
}

export const LeftBarButton: FC<ILeftBarButton> = ({
  children,
  onMenuItemClick,
  tooltip,
}) => {
  const { isAdminApp } = useApplication();
  return (
    <LeftBarLiStyled $isAdminApp={isAdminApp}>
      <NavButtonTooltipWrapper tooltip={tooltip}>
        <button type="button" onClick={onMenuItemClick}>
          {children}
        </button>
      </NavButtonTooltipWrapper>
    </LeftBarLiStyled>
  );
};
